import React, { useState, useEffect } from "react";

// components
import { Loading } from "../_commons/Loading";

// utils
import { trackEvent } from "../../atlas-utils";

const Swiggy = () => {
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		trackEvent("platform_apps_swiggy_accessed", {});
	}, []);

	return (
		<div className="platform-app platform-swiggy-container">
			<iframe
				src="https://partner.swiggy.com/food/pos?pos=true&id=16&accessKey=ngcIduo4DK0LzwAfWDC6OGSviH0s7FIc"
				title="Swiggy Owner App"
				class="swiggy-owner-app-iframe"
				frameborder="0"
				allow="*"
				onLoad={() => setLoading(false)}
			></iframe>
			{loading && <Loading />}
		</div>
	);
};
export default Swiggy;
